import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
// import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import AccountCircle from '@material-ui/icons/AccountCircle';
// import MoreIcon from '@material-ui/icons/MoreVert';
import Button from '@material-ui/core/Button';
import { useTranslation } from "react-i18next";
import { Link, useHistory, useParams, useLocation } from 'react-router-dom';

// import GQLogo from '../assets/image/GenomeQuest.svg';
import GQLogoComponent from '../shared/components/GQLogoComponent';
import LogoutModal from './Modal/LogoutModal';
import LogoutService from '../services/logout';
import AccountService from '../services/accountInfo';
import {url} from "../reducers/url";
import DiscoverService from '../services/discoverService';
import { useSelector, useDispatch } from 'react-redux';
import Switch from '@mui/material/Switch';
import { setToggle } from '../reducers/slice/toggleSlice';
import { setVideoToggle } from '../reducers/slice/videoToggleSlice';
import { Tooltip } from '@mui/material';
import ShareEmailModal from './Modal/ShareEmailModal';
// import MoreVertIcon from '@mui/icons-material/MoreVert';
import { BiDotsVerticalRounded } from "react-icons/bi";
import { useAuth } from 'react-oidc-context';
import useAuthSession from '../hooks/useAuthSession';
import { clearAuthAndSessionState } from '../services/storage/GQStorage';
import gqSupportService, { configureGQSupport } from '../services/gqSupportService';

// GQ Support is hidden from the UI. The /gqsupport route still exists, but nothing
// in the header links to it and the suggestions badge is not fetched. Flip this to
// true to bring the menu entry and its badge back.
const SHOW_GQ_SUPPORT = false;

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        // marginRight: theme.spacing(2),
        '& img': {
            height: '50px'
        },
        '&:hover': {
            backgroundColor: 'transparent',

        },
        // color: 'white',
    },
    inputRoot: {
        color: 'inherit',
    },
    sectionDesktop: {
        display: 'flex',
        // [theme.breakpoints.up('md')]: {
        //     display: 'flex',
        // },
        span: {
            'font-weight': '400'
        },
        '@media print': {
            display: 'none !important'
        }
    },
    sectionMobile: {
        display: 'none',
        // [theme.breakpoints.up('md')]: {
        //     display: 'none',
        // },
    },
    profileText: {
        color: '#5A6868'
    },
    headerNav: {
        padding: '10px 15px 0px',
        paddingLeft: '0',
        backgroundColor: '#fff !important',
        boxShadow: 'none !important',
        color: '#0C90C6 !important',
        margin: '0px',
        width: '96% !important',
        borderBottom: '1px solid #cec7c7',
        '@media print': {
            display: 'block !important',
            visibility: 'visible !important',
            position: 'relative !important',
            backgroundColor: '#fff !important',
            borderBottom: '1px solid #cec7c7',
            '& .pageTitle': {
                display: 'block !important',
                visibility: 'visible !important',
            }
        }
    },

    headerNavDark: {
        padding: '10px 15px 0px',
        paddingLeft: '0',
        backgroundColor: '#292929 !important',
        boxShadow: 'none !important',
        color: '#0C90C6 !important',
        margin: '0px',
        width: '96% !important',
        borderBottom: '1px solid #cec7c7',
        '@media print': {
            display: 'block !important',
            visibility: 'visible !important',
            position: 'relative !important',
            backgroundColor: '#fff !important',
            borderBottom: '1px solid #cec7c7',
            '& .pageTitle': {
                display: 'block !important',
                visibility: 'visible !important'
            }
        }
    },
    headerLink: {
        // alignItems: 'left',
        pointerEvents: 'none',
        backgroundColor: 'transparent'
        // opacity:' 0.5'

    },
    headerPipe: {
        display: 'block',
        margin: '5px 0'
    },
    // '@media (min-width: 780px)': {
    //     headerPipe: {
    //         display: 'block'
    //     }
    // }
    menuList: {
        padding: '0px !important', // Your custom padding here
        position: 'relative',
         top: '100%', /* Moves the menu list below the preferences button */
         left: '0',
         zIndex: '1000',
    },
    anchorTag: {
        textDecoration: 'none',
        color: 'inherit',
    },
}));

function buildSafeHref(candidate, fallback = '#') {
    try {
        const parsed = new URL(candidate, window.location.origin);
        if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
            return fallback;
        }
        return parsed.toString();
    } catch (error) {
        return fallback;
    }
}

export default function Header(props) {
    //const { page } = props;
    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const auth = useAuth();
    //const [anchorEl, setAnchorEl] = React.useState(null);
    //const isMenuOpen = Boolean(anchorEl);
    const { t } = useTranslation('common');
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
    const [mobileMoreAnchorEl1, setMobileMoreAnchorEl1] = React.useState(null);
    const [modalShow, setModalShow] = React.useState(false);
    const [modalShow1, setModalShow1] = React.useState(false);
    const [shareModal, setShareModal] = React.useState(false);
    const [accountInfo, setAccountInfo] = useState({});
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
    const isMobileMenu = Boolean(mobileMoreAnchorEl1);
    const {resid, reportName, reportId} = useParams();
    const [title, setTitle] = useState('');
    const toggle = useSelector(state => state.setToggle.toggle);
    const videoToggle = useSelector(state => state.setVideoToggle.videoToggle);
    const userInfo = useSelector(state => state.setUserInfo);   // holds published flags incl. enableChatbot
    const dispatch = useDispatch();
    const [wfid, setWfid] = useState('');
    const [gqSuggestionCount, setGqSuggestionCount] = useState(0);   // new Q&A suggestions awaiting review
    const authSession = useAuthSession();
    const safeAdminPanelHref = buildSafeHref(`${process.env.REACT_APP_API_URL || ''}${url.adminPanel || ''}`);
    const safeDocsHref = buildSafeHref(`${window.location.origin}${window.location.pathname}#/docs`, `${window.location.pathname}#/docs`);

    /*const handleProfileMenuOpen = (event) => {
        history.push("/accountsettings");
        //setAnchorEl(event.currentTarget);
    };*/

    /*const handleMenuClose = () => {
        setAnchorEl(null);
        // handleMobileMenuClose();
    };*/
    const logout = async () => {
        auth.signoutRedirect();
        clearAuthAndSessionState({ clearOidcKeys: false });

        LogoutService.logout();
        history.push('/login')
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget);
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null);
    };
    const handleMobileMenu = (event) => {
        setMobileMoreAnchorEl1(event.currentTarget);
    };

    const handleMobileMenuClosed = () => {
        setMobileMoreAnchorEl1(null);
    };

    // Close dropdown menus on scroll so they don't detach from the header
    useEffect(() => {
        const handleScroll = () => {
            if (mobileMoreAnchorEl) setMobileMoreAnchorEl(null);
            if (mobileMoreAnchorEl1) setMobileMoreAnchorEl1(null);
        };
        window.addEventListener('scroll', handleScroll, true);
        return () => window.removeEventListener('scroll', handleScroll, true);
    }, [mobileMoreAnchorEl, mobileMoreAnchorEl1]);

    const handleToggle = () => {
        dispatch(setToggle(!toggle));
    };

    const handleVidToggle = () => {
        dispatch(setVideoToggle(!videoToggle));
    };

    const handleLogoutClick = (e) => {
        e.preventDefault(); // Prevent navigation since it's a modal trigger
        setModalShow(true); // Show the modal
    };
    const handleToggleClick = (e) => {
        e.preventDefault(); // Prevent navigation since it's a modal trigger
        setModalShow1(true); // Show the modal
    };

    const fetchAntibodyReportTitle = async () => {
        try {
            const auth = await DiscoverService.getAuthInfoAB(resid);
            const apiKey = auth?.response_content?.gqApiKey;
            const userDir = auth?.response_content?.userDir;
            
            if (!apiKey || !userDir) {
                return 'Search Report - ' + reportName;
            }

            const reportData = await DiscoverService.loadAbReport({
                abReportName: decodeURIComponent(reportName),
                userId: userDir,
                workflowId: resid
            }, apiKey);

            const title = reportData?.aliDocsStats?.auditTrail?.Title;
            return title ? `${title} - ${reportName}` : `Search Report - ${reportName}`;
        } catch (error) {
            console.error('Error fetching report title:', error);
            return 'Search Report - ' + reportName;
        }
    };

    useEffect(() => {
        (async () => {
            try {
                const result = await AccountService.getAccountInfo(history);
                
                if (resid && reportName) { // For Antibody & Result Report
                    if (location.pathname.includes("/antibody/")) {
                        const title = await fetchAntibodyReportTitle();
                        setTitle(title);
                    } else if (location.pathname.includes("/resultreport/")) {
                        setTitle('Graphical Report - ' + reportName);
                    }
                } else if (resid) { // For Discover
                    if (resid.endsWith('.resdb')) {
                        const response = await DiscoverService.getAuthInfo(resid, history);
                        if (response && response.response_content && response.response_content.title) {
                            const workflowid = resid.slice(3);
                            setTitle(response.response_content.title);
                            setWfid(workflowid.slice(0,-6));
                        } else {
                            console.error('Failed to get workflow info');
                            setTitle('Workflow Report');
                        }
                    } else {
                        // New Reports
                        if (location.pathname.includes("/antibody/")) {
                            setTitle('Antibody Search Report');
                        } else if (location.pathname.includes("/resultreport/")) {
                            setTitle('Graphical Report');
                        }
                    }
                } else { // For Others
                    // For Alert Report, use document.title if it's been updated
                    if (location.pathname.includes("/alert-report/") && document.title !== 'React App' && document.title !== 'Alert Report') {
                        setTitle(document.title);
                    } else {
                        setTitle(props.title || '');
                    }
                }
                result && result.response_content ? setAccountInfo(result.response_content) : setAccountInfo({});
            } catch (error) {
                console.error('Error in header useEffect:', error);
                setAccountInfo({});
                setTitle(props.title || '');
            }
        })();
    }, [props.title, resid, reportName, location.pathname, authSession.isLoggedIn]);

    // Q&A suggestions badge for admins. Fetch the count ONCE when the admin logs in,
    // then refresh only when a suggestion's status changes (submitted / approved /
    // dismissed → the 'gqSuggestionsChanged' event). No interval polling.
    // Deps are primitives so this runs on login/identity change only — not on every
    // re-render (the accountInfo/userInfo objects get new references constantly, which
    // previously re-ran this effect and hammered /api/qa/suggestions every few seconds).
    const gqBadgeEmail   = (accountInfo && (accountInfo.email_address || accountInfo.login_name)) || '';
    const gqBadgeIsAdmin = !!(accountInfo && accountInfo.is_admin_class);
    const gqChatbotOn    = !!(userInfo && userInfo.enableChatbot === true);
    useEffect(() => {
        if (!SHOW_GQ_SUPPORT || !gqBadgeIsAdmin || !gqChatbotOn) { setGqSuggestionCount(0); return; }
        let alive = true;
        configureGQSupport(gqBadgeEmail, true);
        const fetchCount = () => {
            gqSupportService.listQASuggestions()
                .then(list => { if (alive) setGqSuggestionCount(Array.isArray(list) ? list.length : 0); })
                .catch(() => { });   // ignore — badge just won't show
        };
        fetchCount();   // once, at login
        const onChanged = () => fetchCount();   // and whenever a suggestion status changes
        window.addEventListener('gqSuggestionsChanged', onChanged);
        return () => { alive = false; window.removeEventListener('gqSuggestionsChanged', onChanged); };
    }, [gqBadgeEmail, gqBadgeIsAdmin, gqChatbotOn]);

    // Watch for document.title changes on alert-report pages
    useEffect(() => {
        if (location.pathname.includes("/alert-report/")) {
            console.log('Alert report page detected, watching document.title');
            const interval = setInterval(() => {
                if (document.title !== 'React App' && document.title !== 'Alert Report') {
                    // console.log('Current document.title:', document.title);
                    setTitle(document.title);
                }
            }, 100);
            return () => clearInterval(interval);
        }
    }, [location.pathname]);
    
    /*const menuId = 'primary-search-account-menu';
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleMenuClose}>
                <Link to="/accountsettings" className={classes.anchorTag}>{t('myAccount')}</Link>
            </MenuItem>
        </Menu>
    );*/

    const menuId2 = 'links-menu';
    const renderMenu2 = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId2}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right'}}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
            classes={{ list: classes.menuList }}
            PaperProps={{
                style: {
                    marginTop: 40,
                },
            }}
        >
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                <Link to="/ipseqsearch" className={classes.anchorTag}>{t('ipSequence')}</Link>
            </MenuItem>
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                {accountInfo && !accountInfo.vmAccess && <span className={classes.pTagMargin + " bodyText"}>{t('sequenceVariation')}</span>}
                {accountInfo && accountInfo.vmAccess && <Link to="/ipseqvariation" className="appLink">{t('sequenceVariation')}</Link>}
            </MenuItem>
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}> 
                {accountInfo && !accountInfo.abAccess && <span className={classes.pTagMargin + " bodyText"}>{t('antibodySequence')}</span>}
                {accountInfo && accountInfo.abAccess && <Link to="/searchresantibody" className="appLink">{t('antibodySequence')}</Link>}
            </MenuItem>
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                {accountInfo && !accountInfo.cmAccess && <span className={classes.pTagMargin + " bodyText"}>{t('cmSequence')}</span>}
                {accountInfo && accountInfo.cmAccess && <Link to="/cmsearch" className="appLink">{t('cmSequence')}</Link>}
            </MenuItem>
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                {accountInfo && !accountInfo.ftAccess && <span className={classes.pTagMargin + " bodyText"}>{t('patentFullText')}</span>}
                {accountInfo && accountInfo.ftAccess && <Link to="/fulltextsearch" className="appLink">{t('patentFullText')}</Link>}
            </MenuItem>
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                <Link to="/patentnumbersearch" className="appLink">{t('patentNumbers')}</Link>
            </MenuItem>
            {/* <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                <Link to="/gqsearch" className="appLink" aria-label="Open GQ Search Assistant">GQ Search Assistant</Link>
            </MenuItem> */}
            <MenuItem onClick={handleMobileMenuClose} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                {accountInfo && <Link to="/searchResult" className="appLink">{t('manageresults')}</Link>}
            </MenuItem>
        </Menu>
    );

    const menuId = 'link-menu';
    const renderMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl1}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'center'}}
            open={isMobileMenu}
            onClose={handleMobileMenuClosed}
            classes={{ list: classes.menuList }}
            PaperProps={{
                style: {
                    marginTop: 40,
                },
            }}
        >
            <MenuItem onClick={handleMobileMenuClosed} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
            <AccountCircle  style= {{color: 'grey'}}/>
                            &nbsp;&nbsp;
                            <Link to="/accountsettings" className={classes.anchorTag}>{accountInfo?.first_name || ''} {accountInfo?.last_name || ''}</Link> 
                            
                {/* <Link to="/accountsettings" className={classes.anchorTag}>{t('myProfile')}</Link> */}
            </MenuItem>
            {accountInfo && accountInfo.is_admin_class && 
            <MenuItem onClick={handleMobileMenuClosed} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                <a href={safeAdminPanelHref} target="_blank"
                                   className="appLink text-capitalize appTextFont"
                                   rel="noreferrer">{t('adminPanel')}</a>
            </MenuItem>}
            {accountInfo && accountInfo.is_admin_class &&
            <MenuItem onClick={handleMobileMenuClosed} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                                    <Link to="/whitelistdomain" className={classes.anchorTag}>Domain Whitelisting</Link>
            </MenuItem>
            }
            {SHOW_GQ_SUPPORT && userInfo && userInfo.enableChatbot === true && accountInfo && accountInfo.is_admin_class &&
            <MenuItem onClick={handleMobileMenuClosed} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                <Link to="/gqsupport" className={classes.anchorTag} aria-label="Open GQ Support Agent">GQ Support</Link>
                {gqSuggestionCount > 0 && (
                    <span
                        title={`${gqSuggestionCount} new suggestion${gqSuggestionCount === 1 ? '' : 's'} awaiting review`}
                        style={{
                            marginLeft: 8, background: '#d32f2f', color: '#fff',
                            borderRadius: 10, fontSize: 11, fontWeight: 700,
                            minWidth: 18, height: 18, lineHeight: '18px',
                            display: 'inline-block', textAlign: 'center', padding: '0 5px',
                        }}>
                        {gqSuggestionCount > 99 ? '99+' : gqSuggestionCount}
                    </span>
                )}
            </MenuItem>
            }
            <MenuItem onClick={handleMobileMenuClosed} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
            <span className={classes.pTagMargin + " bodyText"}>{t('darkTheme')}</span>
            <Switch
                            checked={!toggle}
                            onChange={handleToggle}
                            color="primary"
                            inputProps={{ 'aria-label': 'toggle switch' }}
                        />   
            </MenuItem>
            <MenuItem onClick={handleMobileMenuClosed} style={toggle? {backgroundColor:'white'}:{backgroundColor: '#292929'}}>
                <Link to="#" onClick={handleLogoutClick} className={classes.anchorTag}>{t('logout')}</Link>
                <LogoutModal
                            show={modalShow}
                            onHide={() => setModalShow(false)}
                            tryAgain={() => logout()}
                        // onMessage={errorMessage}
                        />
            </MenuItem>
            
        </Menu>
    );
    return (

        <div className={classes.grow} id = 'sidebarScroll'>
            <AppBar position="static" className={toggle ? classes.headerNav : classes.headerNavDark}>
                <Toolbar style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <GQLogoComponent toLink='#/' />
                    <div className={classes.grow} id = 'sideBarScroll2'/>
                    {/* <Tooltip title="For Dark mode">
                        <Switch
                            checked={!toggle}
                            onChange={handleToggle}
                            color="primary"
                            inputProps={{ 'aria-label': 'toggle switch' }}
                        />
                    </Tooltip> */}
                    <div className={classes.sectionDesktop}>
                        <Button
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenu}
                            color="inherit"
                        >
                            
                            {/* <AccountCircle />
                            &nbsp;&nbsp;
                            <Link to="/accountsettings" className={classes.anchorTag}>{accountInfo.first_name} {accountInfo.last_name}</Link> 
                             */}
                            <span className="appLink text-initial appTextFont">{t('preferences')}</span>
                            {gqSuggestionCount > 0 && (
                                <span
                                    title={`${gqSuggestionCount} new GQ Support suggestion${gqSuggestionCount === 1 ? '' : 's'} awaiting review`}
                                    style={{
                                        marginLeft: 6, background: '#d32f2f', color: '#fff',
                                        borderRadius: 10, fontSize: 11, fontWeight: 700,
                                        minWidth: 18, height: 18, lineHeight: '18px',
                                        display: 'inline-block', textAlign: 'center', padding: '0 5px',
                                    }}>
                                    {gqSuggestionCount > 99 ? '99+' : gqSuggestionCount}
                                </span>
                            )}
                        </Button>
                        <span className={classes.headerPipe}>|</span>
                        <Button color="inherit">
                            <a href={safeDocsHref} target="_blank" rel="noopener noreferrer" className="appLink text-capitalize appTextFont">{t('documentation')}</a>
                        </Button>

                        {/*Currently video tutorials are shown only in Discover Browser page*/}
                        
                        <span className={classes.headerPipe}>|</span>
                        <div style={{paddingTop:'5px' , paddingLeft: '5px'}}>                         
                         <label className=" text-capitalize appTextFont" >Show Video Tutorial</label>
                            <Switch
                                        checked={videoToggle}
                                        onChange={handleVidToggle}
                                        color="warning"
                                        inputProps={{ 'aria-label': 'toggle switch' }}
                                        size="small"
                                    />   
                        </div>
                      
                        {/* {accountInfo && accountInfo.is_admin_class &&
                            <span className={classes.headerPipe}>|</span>
                        }
                        {accountInfo && accountInfo.is_admin_class &&
                            <Button color="inherit">
                                <a href={safeAdminPanelHref} target="_blank"
                                   className="appLink text-capitalize appTextFont"
                                   rel="noreferrer">{t('adminPanel')}</a>
                            </Button>
                        } */}
                        {/* <span className={classes.headerPipe}>|</span> */}
                        {accountInfo && accountInfo.user_class_id != 12 &&
                        <div style={{ fontSize: '20px' }}>
                        <BiDotsVerticalRounded
                            edge="end"
                            aria-label="account of current user"
                            aria-controls={menuId2}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                            style={{ marginTop: '7px' }}
                        >
                            <span className="appLink text-initial appTextFont">{t('quickLaunch')}</span>
                        </BiDotsVerticalRounded>
                        </div>}
                    </div>
                    {/* <div className={classes.sectionMobile}>
                        <IconButton
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >
                            <MoreIcon />
                        </IconButton>
                    </div> */}
                </Toolbar>
                <h5 className={"text-right pageTitle " + (props.title !== '' ? 'p-0' : 'p-2')} style={{marginTop: '5px'}}>
                    {resid && reportId &&
                        <span style={{color: '#337ab7'}}>(Read-Only View) </span>
                    }
                    {/*resid && resid.endsWith('.resdb') && 
                    <Button color="inherit" onClick={() => setShareModal(true)}><span className="appLink text-initial appTextFont" >Share this Workflow</span></Button>
                    */}
                    <span style={{marginLeft:'200px'}}></span>
                    
                    <b>{resid ? title : (location.pathname.includes("/alert-report/") ? title : t(title))}</b></h5>
            </AppBar>

            {/* {renderMobileMenu} */}
            {/* {renderMenu}*/}
            {renderMenu2}
            {renderMenu}
        </div>
    );
}